import { NbDialogRef, NbDialogService } from "@nebular/theme";
import { OfbizFormsService } from "@urbannex/ofbiz-forms";
import { GridCell, RowCell, Section, ContentElement, ContentEnum, ContentElementEnum, ContentStatusEnum } from "@urbannex/storethemes";
import { combineLatest } from "rxjs";
import { ProductEditorDialogComponent } from "../../../dialogs/product-editor-dialog/product-editor-dialog.component";
import { ImageEditorComponent } from "../section-builder-editors/image-editor/image-editor.component";
import { SectionBuilderStoreService } from "../section-builder-store.service";
import { ConfigurationService } from "@urbannex/configuration";
//import { SectionCellStepperComponent } from "./section-cell-stepper.component";
//import { SectionCellStepperComponent } from "./section-cell-stepper.component";

export abstract class BaseCellStepper{
    cell:GridCell | RowCell;
    section:Section;
    contentElements:ContentElement[];
    stepperTitle:string;
    lastStep = false;
    firstStep = true;
    showPlaceholder: boolean = true;
    baseUrl:string;
  
    imgSrc: string;

    contentEnum:ContentEnum;
    cntElementEnum = ContentElementEnum;
    currentCntElementEnum:ContentElementEnum;

 
    constructor(
      //protected ref: NbDialogRef<SectionCellStepperComponent>,
      protected dialogService: NbDialogService,
      protected ofbizFormsService:OfbizFormsService,
      protected sectionBuilderStoreService:SectionBuilderStoreService,
      protected configurationService:ConfigurationService
    ){}

    getStepperTitle(titleEnum){
        let title;
        if((titleEnum).includes(".")){
          let enumKey = titleEnum.split('.')[1] as keyof typeof ContentEnum;
          title = ContentEnum[enumKey];
        }else if(ContentEnum[titleEnum] != undefined){
          title = ContentEnum[titleEnum]
        }else{
          title = titleEnum;
        }
        
        console.log(title)
        
        return title;
      }
  
    onStepChange(e){
      if(e.index == (e.step.stepper.steps.length - 1)){
        this.lastStep = true;
      }
      if(e.index > 0){
        this.firstStep = false;
      }
    }
  
    /* productDialog(mode:string){
      console.log("Opening productDialog - model");
      this.dialogService.open(ProductEditorDialogComponent, {
        closeOnBackdropClick:false,
        context:{
          mode:mode,
        }
      }).onClose.subscribe(resp => {
        const formData = resp["data"]["formData"];
        let link = formData["link"];
        const formName = formData["formName"];
        const formLocation = formData["formLocation"];
        const parts = link.split('/');
        const productId = parts[parts.length - 1]
        console.log(productId);
        combineLatest([
          this.ofbizFormsService.getValue(formData,{productId:productId},null),
          this.ofbizFormsService.getValue({formName:"ProductSummary",formLocation:"component://kwikstore/widget/ProductForms.xml"},{productId:productId},null)
        ])
        .subscribe(([fieldsData,summaryData]:[any,any]) => {
          const formData = fieldsData["data"]["formData"];
          const fields = formData["fields"];
          this.populateContentElements(fields);
          const summary = summaryData["data"]["formData"]
          this.getImageSrc(summary["fields"]);
        })
      })
    } */
    /**
     * 
     * @param fields Fields fetched from the backend and containing the image urls
     */
    getImageSrc(fields:any[]):void{
        //let productId = this.getFieldValue("productId",fields);
      //console.log(productId);
      let smallImageUrl = this.getFieldValue("smallImageUrl",fields);
      if(smallImageUrl != undefined){
        //clean url of htmlsafe characters
        smallImageUrl = decodeURIComponent(smallImageUrl);
        let baseUrl = this.baseUrl.replace("rest/","");
        this.imgSrc = baseUrl+smallImageUrl;
        this.cell.imgSrc = this.imgSrc;
        this.showPlaceholder = false;
        console.log(this.imgSrc)
      }
      //console.log(this.cell)
      //get the productSummary
    }
  
    populateContentElements(fields:any[]):void{
      //Product Name;
      //Price
      //Discount
      //Category
      //Release
      //Normal Price
      //Quick View
      //Release
      //Add to wish list
      //Add to cart
      console.log(this.contentElements);
      let productName = this.getFieldValue("productName",fields);
      console.log(productName);
      let productNameContentEl = this.contentElements.find(cntlEl => cntlEl.fieldName == "productName" || cntlEl.name == "Product Name");
      console.log(productNameContentEl);
      this.contentElements.forEach(contentElement => {
        if(contentElement.fieldName == "productName" || contentElement.name == "Product Name"){
          contentElement.text = this.getFieldValue("productName",fields);
          console.log(contentElement)
        }
        if(contentElement.fieldName == "price" || contentElement.name == "Price"){
          contentElement.text = this.getFieldValue("price",fields);
          console.log(contentElement)
        }
      })
      console.log(fields);
      
  
  
    }

    onChangeContentEl(elId,e){
        //console.log(e);
        let selectedEl = this.cell.contentElements.find(cntEl => cntEl.elId === elId);
        selectedEl.text = e;
      }
  
    getFieldValue(nameKey, fields:any[]){
      let value;
        for (let i=0; i < fields.length; i++) {
          for (let [k,v] of Object.entries(fields[i])) {
            if(k == nameKey){
              //value =  fields[i][k];
              value = v
            }
          }
        }
      return value
    }
  
    imageDialog(){
      this.dialogService.open(ImageEditorComponent, {
        context: {
          title: 'Gallery',
          section:this.section,
          //cellId:this.cell.cellId
        },
      }).onClose.subscribe(() => {
        //Get the rendererType
        this.sectionBuilderStoreService.section$.subscribe(data => {
          console.log(data.rendererType)
          this.section = data;
        })
        this.sectionBuilderStoreService.selectedCell$.subscribe(data => {
          console.log(data);
          let contentEnum = this.getContentEnumValue(data.contentEnum);
          console.log(contentEnum);
          switch (contentEnum) {
            case "Banner":
              this.imgSrc = data.imgSrc;
              break;
            case "Hero Image":
              this.imgSrc = this.section.sectionData.imgSrc;
              console.log(this.section)
              //this.section.sectionData.imgSrc = this.imgSrc;
              this.sectionBuilderStoreService.updateSection(this.section)
              break;
            default:
              console.log("It's not a banner, it's a "+contentEnum)
              //let imgCntEl = data.contentElements.find(cntEl => cntEl.contentElementEnum == "image");
              data.contentElements.forEach(cntEl => {
                let cntEnum = this.getEnumValue(cntEl);
                console.log(cntEnum)
                if(cntEnum == "IMAGE"){
                  cntEl.imgSrc = data.imgSrc;
                  this.imgSrc = data.imgSrc;
                }else{
                  console.log(cntEl.contentElementEnum)
                }
              })
              break;
          }
          
          this.showPlaceholder = false;
        });
      })
    }
  
    onImageError() {
      this.showPlaceholder = true;
    }

    getContentEnumValue(ctnEnum:ContentEnum){
      let enumValue:string;
      if(ctnEnum != undefined){
        if((ctnEnum).includes(".")){
          let enumKey = ctnEnum.split('.')[1] as keyof typeof ContentEnum;
          enumValue = ContentEnum[enumKey];
        }else if(ContentEnum[ctnEnum] != undefined){
          enumValue = ContentEnum[ctnEnum]
        }else{
          enumValue = ctnEnum;
        }
      }
       return enumValue;
    }

    getEnumValue(contentElement:ContentElement){
        let enumValue:string;
        let titleEnum = contentElement.contentElementEnum
        if(titleEnum != undefined){
          if((titleEnum).includes(".")){
            let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
            enumValue = ContentElementEnum[enumKey];
          }else if(ContentElementEnum[titleEnum] != undefined){
            enumValue = ContentElementEnum[titleEnum]
          }else{
            enumValue = titleEnum;
          }
        }
        if(enumValue) enumValue = <string>enumValue.toUpperCase();
        
        return enumValue;
        /* console.log(titleEnum)
        let title;
        if((titleEnum).includes(".")){
          let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
          title = ContentElementEnum[enumKey];
        }else if(ContentElementEnum[titleEnum] != undefined){
          title = ContentElementEnum[titleEnum]
        }else{
          title = titleEnum;
        }
        console.log(title)
        return title */
      }

      /* onSubmitContent(){
        console.log("onSubmitContent")
        this.cell.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
        this.section.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
        this.sectionBuilderStoreService.updateSection(this.section);
        this.sectionBuilderStoreService.updateSelectedCell(this.cell);

      } */

      closeDialog(){
        //this.ref.close()
      }
  }